import { Edit } from '@mui/icons-material'
import { Button, Card, CardContent, Divider, Grid, Typography } from '@mui/material'
import { GreenText, LabelField, LoadingContent } from 'components'
import { VehicleConformityDto, VehicleConformitySendBackToCanadaDto } from 'dtos/vehicles/conformity/index'
import { useState } from 'react'
import { formatDateMoment } from 'utils'
import SendBackToCanadaDialog from './SendBackToCanadaDialog'
import { updateSendBackToCanada } from 'controllers/vehicles/conformity/index'
import { enqueueSnackbar } from 'notistack'

interface SendBackToCanadaCardProps {
  isLoading: boolean
  sendBackToCanada?: VehicleConformitySendBackToCanadaDto
  setState: (values: VehicleConformityDto) => void
  vehicleGuid?: string
}

export default function SendBackToCanadaCard({ isLoading, sendBackToCanada, setState, vehicleGuid }: SendBackToCanadaCardProps) {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false)
  const [isSaving, setIsSaving] = useState<boolean>(false)

  return (
    <>
      <SendBackToCanadaDialog
        initialValues={sendBackToCanada}
        isLoading={isSaving}
        onClose={() => setDialogOpen(false)}
        onSave={values => {
          setIsSaving(true)
          updateSendBackToCanada(vehicleGuid!, values)
            .then(res => {
              enqueueSnackbar('Send Back To Canada Saved Successfully!', { variant: 'success' })
              setDialogOpen(false)
              setState(res.value)
            })
            .finally(() => setIsSaving(false))
        }}
        open={dialogOpen}
      />

      <Card variant='outlined'>
        <CardContent>
          <Grid container spacing={1} alignItems='flex-start'>
            <Grid item xs={12} container alignItems='center' justifyContent='space-between'>
              <Grid item xs={12} sm='auto'>
                <Typography fontWeight='bold' variant='h6'>
                  Send Back To Canada
                </Typography>
              </Grid>

              <Grid item xs={12} sm='auto'>
                <Button disabled={!sendBackToCanada?.needsToBeSentBackToCanada} endIcon={<Edit />} onClick={() => setDialogOpen(true)} variant='text'>
                  EDIT
                </Button>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Divider />
            </Grid>

            <LoadingContent isLoading={isLoading}>
              <Grid item xs={12}>
                <LabelField
                  label='Sent Back To Canada'
                  value={sendBackToCanada?.sentBackToCanadaDate ? formatDateMoment(sendBackToCanada.sentBackToCanadaDate) : undefined}
                />
              </Grid>

              <Grid item xs={12}>
                <LabelField label='Record #' value={sendBackToCanada?.sentBackToCanadaRecordNumber} />
              </Grid>
            </LoadingContent>

            <Grid item xs={12}>
              <GreenText variant='outlined'>
                {`**Send Back To Canada Card:**

The Send Back To Canada Card allows users to enter information related to a vehicle that must be sent back to Canada due to a DOT rejection.

**Edit Button:**

Clicking the Edit Button opens the Edit Send Back To Canada Dialog.

This button is only enabled if "Needs To Be Sent Back To Canada" on the DOT Rejection Card is set to "Yes".

**Sent Back To Canada Label:**

Displays the date entered in the Edit Send Back To Canada Dialog.

**Record # Label:**

Displays the Record Number entered in the Edit Send Back To Canada Dialog.`}
              </GreenText>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  )
}
